const UPDATES = [
  { date: '2026-07-31', text: '《沙丘3》全新预告片发布，维伦纽瓦史诗再续传奇，预计年底全球上映' },
  { date: '2026-07-30', text: '暑期档票房突破200亿大关，《哪吒3》持续领跑动画电影票房榜' },
  { date: '2026-07-29', text: '五姑娘影院新增4K超清专区，50余部经典大片支持4K分辨率为您带来极致画质' },
  { date: '2026-07-28', text: '《流浪地球3》官方宣布定档2027春节，刘德华吴京再度联手拯救地球' },
  { date: '2026-07-27', text: '戛纳电影节金棕榈获奖影片《坠落的审判》独家中文资源已在本站上线' },
  { date: '2026-07-26', text: '《封神第二部》发布首款预告，乌尔善导演构建中国神话宇宙世界观全面升级' },
  { date: '2026-07-25', text: '五姑娘影院移动端体验全面优化，手机观影加载速度提升40%更流畅更省流量' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            影视资讯与站点更新，一手掌握
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300/40 hidden sm:block"></div>

          <div className="space-y-5">
            {UPDATES.map((item, idx) => (
              <div key={idx} className="flex gap-4">
                {/* Date badge */}
                <div className="hidden sm:flex w-[38px] flex-shrink-0 justify-center relative">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500 mt-1.5 z-10"></div>
                </div>

                <div className="flex-1 bg-background-200/40 rounded-lg border border-background-300/30 p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs text-primary-500 font-medium whitespace-nowrap">{item.date}</span>
                    {idx === 0 && (
                      <span className="px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium whitespace-nowrap">
                        最新
                      </span>
                    )}
                  </div>
                  <p className="text-sm md:text-base text-foreground-300 leading-relaxed">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}